"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsProvider_1 = __importDefault(require("../AnalyticsProvider"));
var NissanProvider = /** @class */ (function (_super) {
    __extends(NissanProvider, _super);
    function NissanProvider(name, config) {
        var _this = _super.call(this, name) || this;
        _this.config = config;
        return _this;
    }
    /**
     * If we were passed an eventCallback, send the payload there.
     *     This is typical in Electric, where we want to push onto the parent window (dealer website) dataLayer.
     * If we were *not* passed an eventCallback, look for window.dataLayer.push in our context
     *     This is typical in Redline
     * Note that Google replaces the entire window.dataLayer object when it finishes loading, it is *not* safe to hold onto a reference to the push method directly.
     * @param payload
     * @protected
     */
    NissanProvider.prototype.eventHandler = function (payload) {
        var eventHandler = this.config.eventCallback || window.dataLayer.push;
        eventHandler(payload);
    };
    NissanProvider.prototype.opened = function () {
        this.eventHandler({
            event: "nissan-t3-tagging-TrackPaymentEstimator",
        });
    };
    NissanProvider.prototype.leadFormFinished = function (dealId) {
        this.eventHandler({
            event: "nissan-t3-tagging-TrackSignUp",
            "nissan-t3-tagging": {
                formCategory: "sign-up",
                formLeadId: dealId,
                formName: "sign-up",
                formType: "sign-up",
            },
        });
    };
    NissanProvider.prototype.signInToGarageGarageIcon = function (dealId) {
        this.eventHandler({
            event: "nissan-t3-tagging-TrackSignIn",
            "nissan-t3-tagging": {
                formCategory: "sign-in",
                formLeadId: dealId,
                formName: "sign-in",
                formType: "sign-in",
            },
        });
    };
    NissanProvider.prototype.signInComplete = function (dealId) {
        this.eventHandler({
            event: "nissan-t3-tagging-TrackSignIn",
            "nissan-t3-tagging": {
                formCategory: "sign-in",
                formLeadId: dealId,
                formName: "sign-in",
                formType: "sign-in",
            },
        });
    };
    return NissanProvider;
}(AnalyticsProvider_1.default));
exports.default = NissanProvider;
